import React from "react";
import { observer } from "mobx-react-lite";
import LoadingIcon from "components/LoadingIcon";
import { usePropertyBrowserStore } from "./PropertyBrowserStoreContext";

const PropertyBrowserScrollTrigger = observer(
  function PropertyBrowserScrollTrigger({
    parentNodeId,
  }: {
    parentNodeId: string | null;
  }) {
    const store = usePropertyBrowserStore();
    const ref = React.useRef<HTMLDivElement>(null);
    const isLoading = store.loadingNodes.has(parentNodeId);

    React.useEffect(() => {
      const el = ref.current;
      if (!el) return;
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting && !store.loadingNodes.has(parentNodeId)) {
            store.fetchMore(parentNodeId);
          }
        },
        { threshold: 0.1 }
      );
      observer.observe(el);
      return () => observer.disconnect();
    }, [parentNodeId, store]);

    return (
      <div ref={ref} className="flex justify-center py-2">
        {isLoading && <LoadingIcon type="gray" className="w-4 h-4" />}
      </div>
    );
  }
);

export default PropertyBrowserScrollTrigger;
